import styled from "styled-components";
import Modal from "react-bootstrap/Modal";

export const StyledModal = styled(Modal)`
  .modal-content {
    top: 4rem;
    border-radius: 12px;
    background: var(--bg-color);
    box-shadow: ${({ $shadow }) => $shadow && "var(--box-shadow1)"};
    border: none;
  }
  .modal-dialog {
    margin: 0 auto;
    max-width: ${({ $maxWidth }) => $maxWidth && $maxWidth};
  }
`;
